module.exports = __webpack_public_path__ + "static/media/Artie 4.8dc18de5.jpg";